import { ENV_MODE } from "constants/constants";

export const isProduction = () =>
	process.env.REACT_APP_ENV === ENV_MODE.PRODUCTION ||
	process.env.REACT_APP_ENV === ENV_MODE.UAT;

export const isUat = process.env.REACT_APP_ENV === ENV_MODE.UAT;
export const isStag = process.env.REACT_APP_ENV === ENV_MODE.STAGING;
export const isProd = process.env.REACT_APP_ENV === ENV_MODE.PRODUCTION;
